// export const serverIp = 'http://localhost:9091/server';    //本地
// export const serverIp = "http://121.40.142.54:4006/server"; //zj阿里云服务器
// export const serverIp = "http://54.250.93.39:4006/server"; //亚马逊服务器
export const serverIp = 'https://iimc.hdu.edu.cn/server'; //hdu服务器
// export const serverIp = "http://101.34.81.202:4006/server"; //腾讯云服务器

//百度地图ak
export const ak = "TLu9zRGzVUuishHieGGQDCUBrPir1750";